import type { PriceScenariosProps } from "../../types";
import { Arrow } from "../Arrow";
import { Value } from "../Value";

export const ValueWithArrow = (props: PriceScenariosProps) => (
  <Arrow>
    <Value {...props} />
  </Arrow>
);
